<div class="students-page">
  <div class="page-head">
    <div>
      <h1 class="page-title">Student information</h1>
      <p class="page-sub">Search and manage students. Select a row to open the full profile.</p>
    </div>
  </div>

  <mat-card class="list-card">
    <div class="toolbar">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Name, roll, class, email…" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <button mat-flat-button color="primary" type="button" (click)="openCreateStudent()">
        <mat-icon>person_add</mat-icon>
        Create student
      </button>
    </div>

    <div class="table-wrap">
      <table mat-table [dataSource]="students" class="students-table">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }} {{ element.lastName }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="mobileNumber">
          <th mat-header-cell *matHeaderCellDef>Mobile</th>
          <td mat-cell *matCellDef="let element">{{ element.mobileNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="rollNumber">
          <th mat-header-cell *matHeaderCellDef>Roll number</th>
          <td mat-cell *matCellDef="let element">{{ element.rollNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="className">
          <th mat-header-cell *matHeaderCellDef>Class</th>
          <td mat-cell *matCellDef="let element">{{ element.className }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
          <td mat-cell *matCellDef="let element" class="actions-cell" (click)="$event.stopPropagation()">
            <button
              mat-icon-button
              type="button"
              color="primary"
              matTooltip="Edit student"
              aria-label="Edit student"
              (click)="openEditStudent($event, element)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              color="warn"
              matTooltip="Delete student"
              aria-label="Delete student"
              (click)="deleteStudent($event, element)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="student-data-row"
          (click)="openStudentDetails(row)"
        ></tr>
      </table>
    </div>
  </mat-card>
</div>
